import { useConfig } from 'providers/config/ConfigProvider';
import { GHubTheme, GHubThemeVariant } from '@sanlam-glacier/app-common/modules/theme';
import { PropsWithChildren } from 'react';

type ThemeProps = {
  variant?: GHubThemeVariant;
};

export const Theme = ({ variant, children }: PropsWithChildren<ThemeProps>) => {
  const { theme } = useConfig();
  return (
    <GHubTheme theme={theme} variant={variant}>
      {children}
    </GHubTheme>
  );
};
